import { render, staticRenderFns } from "./DetailViewTableTable.vue?vue&type=template&id=c6529a5c"
import script from "./DetailViewTableTable.vue?vue&type=script&lang=js"
export * from "./DetailViewTableTable.vue?vue&type=script&lang=js"
import style0 from "./DetailViewTableTable.vue?vue&type=style&index=0&id=c6529a5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports